/** The backend's default store time zone. */
export const DEFAULT_TIME_ZONE = 'America/New_York';

// Intl lists Asia/Calcutta rather than Asia/Kolkata in some engines and never lists UTC; the
// backend resolves both, and they are the ones operators look for.
const ALWAYS_OFFERED = ['UTC', 'Asia/Kolkata', DEFAULT_TIME_ZONE];

/** Every IANA zone this browser knows, sorted, for store time zone pickers. */
export function timeZoneOptions(): string[] {
  const known =
    typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
  return [...new Set([...known, ...ALWAYS_OFFERED])].sort((a, b) => a.localeCompare(b));
}

/** "America/Los_Angeles" reads as "America/Los Angeles". */
export function timeZoneLabel(zone: string): string {
  return zone.replaceAll('_', ' ');
}
